import React from 'react';
import { IMyEquityRow } from './IMyEquityRow';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import { classNames } from '@features/utils/reactFunctions';
import SkeletonLoader from '@appComponents/SkeletonLoader/SkeletonLoader';
import AsyncImage from '@appComponents/AsyncImage/AsyncImage';
import noPhotoCompany from '@images/no_photo_company.png';

import * as style from './MyEquityRowStyle.module.scss'

const MyEquityRow: React.FunctionComponent<IMyEquityRow> = (props) => {
  return props.loader ? (
    <div className={style.skeletonWrapper}>
      <SkeletonLoader circle={true} height={40} width={40} purple={true} />
      <SkeletonLoader height={30} purple={true} />
      <SkeletonLoader height={30} purple={true} />
    </div>
  ) : (
      <>
        <AsyncImage image={props.avatarUrl || null} fallback={noPhotoCompany}>
          <img
            className={classNames(
              style.imageWrapper, props.borderColor, typeof props.avatarUrl === 'undefined' && style.background
            )}
          />
        </AsyncImage>
        <p className={style.name}>{props.name}</p>
        <p className={style.amount}><CurrencyElement value={props.value} currency="usd" /></p>
      </>
    );
};

export default MyEquityRow;
